export const RESOURCES_SLUG = 'resources'
